import { Input, InputGroup, InputLeftElement } from "@chakra-ui/react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { debounce, DebouncedFunction } from "src/common";
import { useLightMode } from "src/common/hooks/lightMode";

const CompassInput = ({ isDebounced, ...props }: any) => {
  if (isDebounced) {
    return <DebouncedInput {...props} />;
  } else {
    return <NormalInput {...props} />;
  }
};

const debouncedSearch: DebouncedFunction = debounce(
  (value: string, callback: (val: string) => void) => {
    callback(value);
  },
  250,
);

const DebouncedInput = (props) => {
  const [val, setVal] = useState(props.value || "");

  const handleChange = (e) => {
    const query = e.target.value;
    // Sanitize input so that the first character can't be a blank space
    if (query.charCodeAt(0) !== 32) {
      setVal(query);
      debouncedSearch(e, props.onChange);
    }
  };
  return <NormalInput {...props} value={val} onChange={handleChange} />;
};

const NormalInput = (props) => {
  const { lightMode } = useLightMode();
  const primaryColor = useSelector((state: any) => {
    return lightMode
      ? state?.application?.colors?.light?.primary
      : state?.application?.colors?.dark?.primary;
  });
  const { LeftIcon, ...rest } = props;
  return (
    <InputGroup
      position="relative"
      color={props.color || "black"}
      size={props.size || "md"}
      w={props.width}
    >
      {props.LeftIcon && (
        <InputLeftElement
          pointerEvents="none"
          color="gray.300"
          children={<LeftIcon />}
        />
      )}
      <Input
        focusBorderColor={primaryColor}
        color="black"
        backgroundColor="white"
        _placeholder={{ color: "gray" }}
        autoCorrect="off"
        spellCheck="false"
        autoComplete="off"
        {...rest}
      />
    </InputGroup>
  );
};

export default CompassInput;
